export class CompanyLicense {
  id: number;
  name: string;
  number: string;
  companyLicenseTypeId: number;
  issuanceDate: string;
  expiryDate: string;
  isCurrent: boolean;
  companyId: number;
}



// WEBPACK FOOTER //
// ./src/app/core/models/company-license.ts